module.exports = __webpack_public_path__ + "media/complete2.c26b8d6b.wav";